import { Link, useParams } from "react-router-dom";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { Breadcrumbs } from "@/components/site/Blocks";
import { CtaBand } from "@/components/site/Cta";
import { getGuide, GUIDES } from "@/data/guides";
import { SITE_URL } from "@/data/site";
import NotFound from "./NotFound";

export default function GuidePage() {
  const { slug } = useParams();
  const g = getGuide(slug);
  if (!g) return <NotFound />;
  const crumbs = [{ label: "Home", to: "/" }, { label: "Guide", to: "/guide" }, { label: g.title, to: `/guide/${g.slug}` }];
  const ld = { "@context": "https://schema.org", "@type": "Article", headline: g.title, description: g.description, dateModified: g.updated, author: { "@type": "Organization", name: "STUDIO WEB NS" }, publisher: { "@type": "Organization", name: "STUDIO WEB NS" }, mainEntityOfPage: `${SITE_URL}/guide/${g.slug}` };
  return (
    <>
      <Seo path={`/guide/${g.slug}`} title={`${g.title} | STUDIO WEB NS`} description={g.description} jsonLd={[crumbsLd(crumbs), ld]} />
      <article className="py-12 sm:py-16">
        <div className="wrap max-w-3xl">
          <Breadcrumbs items={crumbs} />
          <p className="eyebrow">{g.category}</p>
          <h1 className="mt-4 text-4xl font-extrabold leading-[1.08] sm:text-5xl">{g.title}</h1>
          <p className="lead-text mt-6">{g.excerpt}</p>
          <div className="mt-4 flex flex-wrap gap-2 text-xs text-slate-600">
            <span>Aggiornato: {g.updated}</span>
            {g.tags.map((t) => <span key={t} className="rounded-full border border-slate-200 px-2.5 py-0.5">#{t}</span>)}
          </div>
          <div className="prose-swns mt-6 border-t border-slate-100 pt-2">
            {g.body.map((b) => <section key={b.h2}><h2>{b.h2}</h2><p>{b.p}</p></section>)}
          </div>
          <div className="mt-16 border-t border-slate-100 pt-8">
            <p className="text-sm font-semibold text-slate-600">Altre guide</p>
            <ul className="mt-4 space-y-2">
              {GUIDES.filter((x) => x.slug !== g.slug).slice(0, 3).map((x) => <li key={x.slug}><Link to={`/guide/${x.slug}`} className="font-medium text-slate-900 hover:text-blue-600">{x.title}</Link></li>)}
            </ul>
          </div>
        </div>
      </article>
      <CtaBand />
    </>
  );
}
